module.exports = {
  'X-User-Email': $('meta[name="email"]').attr('content'),
  'X-User-Token': $('meta[name="token"]').attr('content'),
}
